import { Eye } from "tabler-icons-react";

export const SkillsHeaders = [
  { id: "id", numeric: true, disablePadding: true, label: "ID" },

  //give full width to the question column
  {
    id: "categoryName",
    numeric: false,
    disablePadding: true,
    label: "Category",
  },
  {
    id: "categoryDescription",
    numeric: false,
    disablePadding: true,
    label: "Description",
  },
  {
    id: "actions",
    view: <Eye />,

    numeric: false,
    label: "Actions",
  },
];
